export enum PacingStatus {
  UnderPacing = 'Under Pacing',
  RiskPacing = 'Risk Pacing',
  OnTarget = 'On Target',
  OverPacing = 'Over Pacing',
}
